import { render, staticRenderFns } from "./CopyrightAmendmentMessages.vue?vue&type=template&id=4d35d272&scoped=true&"
import script from "./CopyrightAmendmentMessages.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d35d272",
  null
  
)

export default component.exports